import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import classes from './ProjectViewer.module.css'
import { postsApi } from "../../../../utils";
import { throwApiError } from "../../../lms-shared/store/error-handling-actions";
import { applicationActions } from "../../../../store/application-slice";
import IdeRunner from "../../../lms-shared/IdeRunnerWarrper/IdeRunner";
import { ObjectTypeNamesEnum } from "../../../../models/ObjectTypeEnum";
import SuccessProjectPopup from "../../../lms-shared/UI/Popups/SuccessProjectPopup/SuccessProjectPopup";

const ProjectViewer = () => {

    const dispatch = useDispatch();
    const baseDispatch = useDispatch()

    const { texts, lang } = useSelector(state => state.translate);
    const applicationId = useSelector(state => state.application.applicationId);
    const uiData = useSelector((state) => state.general.uiData);

    const { applictionName, postId } = useParams();

    const [projectData, setProjectData] = useState()
    const [showPopup, setShowPopup] = useState()

    useEffect(() => {
        if (uiData) {
            dispatch(applicationActions.setInitial({ applictionName, uiData }))
        }
    }, [dispatch, uiData])

    useEffect(() => {
        if (lang && postId) {
            postsApi.postsFilterIdPost(postId, (error, resdata, response) => {
                if (error) {
                    baseDispatch(throwApiError({ userMessage: texts.projectsFilterIdError, error: error, statusCode: response?.statusCode, message: "projectsFilterIdPost " + error.message, level: 2, component: "Project", line: 58 }))
                } else {
                    if (resdata) {
                        let ide = JSON.parse(resdata.contentData)
                        setProjectData({
                            assessmentName: resdata.name,
                            ideUrl: ide.Ide.Url,
                            ideLang: ide.Ide.Lang ? ide.Ide.Lang : lang,
                            ideConfig: JSON.parse(ide.Ide.AdditionalConfiguration),
                            fileUrl: resdata.url,
                            share: false,
                            author: `${resdata.user?.firstName} ${resdata.user?.lastName}`,
                        })
                    }
                }
            })
        }
    }, [lang]);

    const handleCopyProject = () => {
        let data = {
            id: postId,
            refObjectType: ObjectTypeNamesEnum.Application,
            refObjectId: applicationId
        }
        postsApi.postsImportRefObjectPost({ postImportRefObjectInput: data }, (error, resdata, response) => {
            if (error) {
                baseDispatch(throwApiError({ userMessage: "error in postsImportRefObjectPost", error: error, statusCode: response?.statusCode, message: "postsImportRefObjectPost " + error.message, level: 1, component: "Project", line: 60 }))
            }
            else {
                setShowPopup(<SuccessProjectPopup myHeight='216px' title={texts.copyToMyDrafts} close={() => setShowPopup(false)} color="#CCF0F0"><div className={classes.SuccessIconAndText}>{texts.successImportPost}</div></SuccessProjectPopup>)
            }
        })
    }

    return (
        <div>
            <div className={classes.Header}>
                <div className={classes.Container}>
                    <div className={classes.Text}>{texts.author} {projectData?.author}</div>
                    <div className={classes.AssessmentImg}></div>
                    <div className={classes.Text}>
                        <div className={classes.InnerText}>{projectData?.assessmentName}</div>
                    </div>
                    <div className={classes.CopyCodeContainer} onClick={() => handleCopyProject()}>
                        <div className={classes.CopyText}>{texts.copyToMyDrafts}</div>
                        <div className={classes.CopyIcon}></div>
                    </div>
                </div>
            </div>
            <div className={classes.IdeRunnerWarrper}>
                {projectData && <IdeRunner projectData={projectData}> </IdeRunner>}
            </div>
            {showPopup}
        </div>
    )
}
export default ProjectViewer